import(/* webpackMode: "eager" */ "/Users/altahan/Desktop/trq/trq_age/app/[locale]/globals.css");
;
import(/* webpackMode: "eager", webpackExports: ["ThemeProvider"] */ "/Users/altahan/Desktop/trq/trq_age/app/provider.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/Users/altahan/Desktop/trq/trq_age/components/AppContainer.tsx");
;
import(/* webpackMode: "eager" */ "/Users/altahan/Desktop/trq/trq_age/lib/gsap.ts");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/Users/altahan/Desktop/trq/trq_age/node_modules/next-intl/dist/esm/shared/NextIntlClientProvider.js");
;
import(/* webpackMode: "eager" */ "/Users/altahan/Desktop/trq/trq_age/node_modules/next/font/google/target.css?{\"path\":\"app/[locale]/layout.tsx\",\"import\":\"Inter\",\"arguments\":[{\"subsets\":[\"latin\"]}],\"variableName\":\"inter\"}");
;
import(/* webpackMode: "eager" */ "/Users/altahan/Desktop/trq/trq_age/node_modules/slick-carousel/slick/slick.css");
;
import(/* webpackMode: "eager" */ "/Users/altahan/Desktop/trq/trq_age/node_modules/slick-carousel/slick/slick-theme.css");
